export default __webpack_public_path__ + "static/gabor_tamas_portrait_mobile-6fb82bcd06f71b3f3897f0137056c4a5.jpg";